import React from 'react';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import { Redirect as AppRedirect } from 'wanderu-component-react-router-link';
import {
    ScrollToTopOnMount,
} from 'wanderu-hocs';

const AccountSettingsContainer = withInterstitial(import('./containers/AccountSettings/AccountSettings'));
const CompleteResetPasswordContainer = withInterstitial(import('./containers/CompleteResetPassword/CompleteResetPassword'));
const LoginContainer = withInterstitial(import('./containers/LogIn/LogIn'));
const MyTripsContainer = withInterstitial(import('./containers/MyTrips/MyTrips'));
const ResetPasswordContainer = withInterstitial(import('./containers/ResetPassword/ResetPassword'));
const SignUpContainer = withInterstitial(import('./containers/SignUp/SignUp'));
const PointsContainer = withInterstitial(import('./containers/Points/Points'));
const UserAccountsPage = withInterstitial(import('./pages/UserAccounts'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});
const InviteContainer = withInterstitial(import('./pages/Invite'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});
const ReferredSignUpContainer = withInterstitial(import('./pages/ReferredSignUp'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

export default [
    {
        path: '/account',
        key: '/account',
        component: UserAccountsPage,
        routes: [
            {
                path: '/account/settings',
                key: '/account/settings',
                component: ScrollToTopOnMount(AccountSettingsContainer),
            },
            {
                path: '/account/login',
                exact: true,
                key: '/account/login',
                component: ScrollToTopOnMount(LoginContainer),
            },
            {
                path: '/account/signup',
                key: '/account/signup',
                exact: true,
                component: ScrollToTopOnMount(SignUpContainer),
            },
            {
                path: '/account/resetPassword',
                key: '/account/resetPassword',
                component: ScrollToTopOnMount(ResetPasswordContainer),
            },
            {
                path: '/account/completeResetPassword',
                key: '/account/completeResetPassword',
                component: ScrollToTopOnMount(CompleteResetPasswordContainer),
            },
            {
                path: '/account/mytrips/:tripsType?',
                key: '/account/mytrips/:tripsType?',
                component: ScrollToTopOnMount(MyTripsContainer),
            },
            {
                path: '/account/points',
                key: '/account/points/',
                component: ScrollToTopOnMount(PointsContainer),
            },
            {
                path: undefined,
                key: 'account-catchall',
                component: () => {
                    return (
                        <AppRedirect href="/account/" />
                    );
                },
            },
        ],
    },
    {
        path: '/invite',
        key: '/invite',
        component: ScrollToTopOnMount(InviteContainer),
    },
    {
        path: '/rf/:referralCode',
        key: '/rf/:referralCode',
        component: ScrollToTopOnMount(ReferredSignUpContainer),
    },
];
